import { useEffect, useState } from 'react';

export default function useHorizontalScroll(ref) {
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const el = ref.current;

    const update = () => {
      const maxScrollLeft = el.scrollWidth - el.clientWidth;

      setShowLeft(el.scrollLeft > 1);
      setShowRight(el.scrollLeft < maxScrollLeft - 1);
    };

    update();
    el.addEventListener('scroll', update);
    window.addEventListener('resize', update);

    return () => {
      el.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [ref]);

  const scrollToStart = () => {
    ref.current?.scrollTo({ left: 0, behavior: 'smooth' });
  };

  const scrollToEnd = () => {
    const el = ref.current;
    if (!el) return;

    const maxScrollLeft = el.scrollWidth - el.clientWidth;

    el.scrollTo({
      left: maxScrollLeft,
      behavior: 'smooth',
    });
  };

  return {
    showLeft,
    showRight,
    scrollToStart,
    scrollToEnd,
  };
}
